export default (
  state = {
    busy: true,
    profile: null,
    contactInfo: {},
    goals: null,
    scores: null,
  },
  { type, ...rest },
) => {
  switch (type) {
    case 'STUDENT_PROFILE/TOGGLE_BUSY_ON':
      return {
        ...state,
        busy: true,
      };

    case 'STUDENT_PROFILE/TOGGLE_BUSY_OFF':
      return {
        ...state,
        busy: false,
      };

    case 'STUDENT_PROFILE/POPULATE_PROFILE':
      return {
        ...state,
        profile: rest.profile,
      };

    case 'STUDENT_PROFILE/POPULATE_DATA_CHOICES':
      return {
        ...state,
        dataChoices: rest.dataChoices,
      };

    case 'STUDENT_PROFILE/POPULATE_CONTEXT':
      return {
        ...state,
        context: rest.context,
      };

    case 'STUDENT_PROFILE/POPULATE_BADGE_COUNT':
      return {
        ...state,
        badgeCount: rest.badgeCount,
      };

    case 'STUDENT_PROFILE/POPULATE_STUDENT_CONTACT_INFO':
      return {
        ...state,
        contactInfo: rest.contactInfo,
      };

    case 'STUDENT_PROFILE/POPULATE_GOALS':
      return {
        ...state,
        goals: rest.goals,
      };

    case 'STUDENT_PROFILE/POPULATE_SCORES':
      return {
        ...state,
        scores: rest.scores,
      };

    default:
      return state;
  }
};
